export default __webpack_public_path__ + "static/media/MaisonNeue-Book.fd1e3907.woff2";